import lineBreaker from 'helpers/LineBreaker';
import '../styles.scss';
import React from 'react';
import Chart from 'react-apexcharts';
import SemDados from '../SemDados';

const RegiaoImpresso = (props) => {
  const { data } = props;

  const titulo = 'Quantidade de impressos por regional';

  if (!data || Object.keys(data).length === 0)
    return <SemDados titulo={titulo} />;

  const regioes = Object.keys(data);

  const series = [{ data: regioes.map((regiao) => data[regiao]) }];

  const options = {
    colors: ['#021f59'],
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top',
          hideOverflowingLabels: true,
          orientation: 'horizontal',
        },
      },
    },
    xaxis: {
      labels: {
        formatter: (value) => {
          const lines = lineBreaker(value.toUpperCase(), 16);
          return lines;
        },
        show: true,
        rotate: 0,
        hideOverlappingLabels: false,
        trim: false,
        rotateAlways: false, // mudar para true se quiser que todas as labels sejam rotacionadas
      },
      categories: regioes,
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: true,
      max: Math.max(...regioes.map((regiao) => data[regiao])) * 1.6,
      labels: {
        show: false,
      },
    },
    grid: {
      show: false,
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    chart: {
      height: 'auto',
      id: 'reg-solicitacoes',
      parentHeightOffset: 0,
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      textAnchor: 'middle',
      offsetX: 0,
      offsetY: -20,
      formatter: (value) => {
        return `${parseInt(value, 10).toLocaleString('pt-BR')}`;
      },
      style: {
        fontSize: '12px',
        fontWeight: 550,
        colors: ['#373d3f'],
      },
    },
    tooltip: {
      followCursor: true,
      intersect: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      // eslint-disable-next-line
      custom: ({ series, seriesIndex, dataPointIndex }) => {
        return `<div class="arrow_box">
            <span>
              Regional: <span id="data">${regioes[
                dataPointIndex
              ].toUpperCase()}</span>
            </span>
            <span>
              Quantidade impressos: <span id="data">${parseInt(
                series[seriesIndex][dataPointIndex],
                10
              ).toLocaleString('pt-BR')}</span>
            </span>
          </div>
          `;
      },
    },
  };

  return (
    <div className="grafico">
      <div className="grafico-titulo">
        <span>{titulo}</span>
      </div>
      <Chart options={options} series={series} type="bar" height="360" />
    </div>
  );
};

export default RegiaoImpresso;
